import type { FC } from "react";
import { useCallback } from "react";
import type { ETypes } from "app/pages/industry-analysis/players/table/bubble-chart/types";
import { TitlesPositioner } from "app/components/React/Charts/titles-positioner/TitlesPositioner";
import { CHART_OPTIONS_META_DATA } from "app/pages/industry-analysis/players/table/bubble-chart/const";
import { translate } from "app/filters/i18nFilter";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

interface IQuadrantTitles {
    type: ETypes;
}

const { carbon } = colorsPalettes;

const QuadrantTitle = styled.span`
    ${setFontVariant("input2", carbon[250])}
`;

const getTitles = (type: ETypes) => {
    const { quadrantNameKeys } = CHART_OPTIONS_META_DATA[type];
    const titles = Object.keys(quadrantNameKeys).reduce((titles, position) => {
        return {
            ...titles,
            [position]: <QuadrantTitle>{translate(quadrantNameKeys[position])}</QuadrantTitle>,
        };
    }, {});
    return titles;
};

export const QuadrantTitles: FC<IQuadrantTitles> = (props) => {
    const { type } = props;
    const titles = useCallback(() => getTitles(type), [type]);
    return <>{titles && <TitlesPositioner titles={titles()} />}</>;
};
